/*
 * @Description: 
 * @Version: 
 * @Autor: 
 * @Date: 2022-02-16 09:24:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-18 09:13:16
 */
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')

export const i_0015_search = (month, userCd) => {
  return http.requestGet(apiUrl.apiUrl_holidaySearch + '?month=' + month + '&userCd=' + userCd)
}
export const i_0015_detail_search = (jobDate) => {
  return http.requestGet(apiUrl.apiUrl_holidayDetailSearch + '?jobDate=' + jobDate)
}
export const i_0015_update = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_holidaySave + '?userCd=' + userCd, params)
}


// WEBPACK FOOTER //
// ./src/module/api/i_0015.js